module.exports = __webpack_public_path__ + "img/house-signal.037f5f9a.svg";